import { splitsList, splitTreatments } from '../constants';

export default (treatmentKey, state) => {
  if (!treatmentKey || !state.split || !state.split.treatments || !Object.values(splitsList).includes(treatmentKey)) {
    return undefined;
  }

  return state.split.treatments[treatmentKey] ? splitTreatments.on : splitTreatments.off;
};
